import * as React from 'react';

import PlanOptions from '../PlanOptions';
import WorkflowStep from '../WorkflowStep';
import Button from '../../components/buttons/Button';

interface Props {
	actions: any;
	history: any;
	match: any;
	planOptions: CustomerPolicyDto[];
	customerDetails: CustomerDemographicDetails;
	user: UserDetails;
	onCustomerPolicySelect: (plan: CustomerPolicy) => void;
}
interface State {
	isLoading: boolean;
}
class SimpleSelectYourPlanPage extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			isLoading: true
		};
	}

	componentDidMount() {
		const { gender, birthDate, id } = this.props.user;
		const { isSmoker, age } = this.props.customerDetails;
		if (age == null || age < 18 || age > 65 || gender == null || isSmoker == null) {
			this.back();
		}
		else {
			const params: GetSimplePoliciesRequest = {
				gender: gender,
				smoking: isSmoker,
				birthdate: birthDate,
				userId: id
			};
			this.props.actions.fetchSimplePlanOptions(params)
				.then(() => this.setState({ isLoading: false }));
		}
	}

	back = () => {
		this.props.history.push(`/quote/${this.props.match.params.workflow}/about-you`);
	}

	toCustomPolicy = () => {
		// const policy = this.props.planOptions[Math.floor(this.props.planOptions.length / 2)]; // set the middle option
		this.props.actions.setCustomerPolicy(this.props.planOptions);
		this.props.history.push(`/quote/Custom/select-your-policy`);
	}

	render() {
		if (this.props.planOptions.length > 0) {
			return (
				<WorkflowStep
					title={`We offer a range of protection products to meet your needs. Below are some popular options.`}
				>
					<PlanOptions
						{...this.props}
						workflow={this.props.match.params.workflow}
						isLoading={this.state.isLoading}
						className="text-center"
					/>
					<div className="mt-5 text-center">
						<div>
							<p className="mx-auto max-read-width">Need help deciding?</p>
							<Button to="/quote/B/your-needs" className="btn-outline-primary mb-4">Use our calculator</Button>
						</div>
						<div>
							<p className="mx-auto max-read-width">Need a different coverage amount or term?</p>
							<Button className="btn-outline-primary" onClick={this.toCustomPolicy}>Build a custom policy</Button>
						</div>
					</div>
				</WorkflowStep>
			);
		}
		else {
			return (
				<WorkflowStep
					title="Sorry, we currently do not have any plans available for you."
				/>
			);
		}
	}
}

export default SimpleSelectYourPlanPage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/simple/SimpleSelectYourPlanPage.tsx